
import {  SiriusBaseComponent } from 'sirius-framework';
import { Component, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { IndividualSalesService } from '../../../inner-menu-sales/inner-menu-sales.service';
import { ValidationService } from '../../../shared/service/validation-service';
import { CommonService } from '../../../shared/service/shared.service';
import { SharedModel } from '../../../shared/models/shared.model';
import { SalesTransactionInformationModel } from '../../../shared/models/salesinformation.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MemberInfo } from '../../../shared/models/shared.model';
import { TransactionNames } from '../../../shared/constants/constants'
import { OwnAccountsComponent } from '../../../popup/own-accounts/own-accounts.component';
import { MessageShowComponent } from '../../../popup/message-show/message-show.component';

declare const $: any;

/** String resource — boşsa Türkçe varsayılan; mevcut sales_* anahtarları korunur */
const SALES_INDIVIDUAL_KEYS = {
    confirmMessage: 'sales_ConfirmMessage',
    confirmMessageComm: 'sales_ConfirmMessageComm',
    resultMessage: 'sales_ResultMessage',
    errorMessage: 'sales_ErrorMessage',
    plateErrorResource: 'sales_LicencePlateError',
    amountMinThanCommissionError: 'sales_AmountMinThanCommissionError',
    sellerIbanMessage: 'SellerIbanMessage',
    confirmMessageExtra: 'sales_confirmMessageExtra',
    headingSellerInfo: 'yediEminSalesIndHeadingSellerInfo',
    headingSalesInfo: 'yediEminSalesIndHeadingSalesInfo',
    headingConfirm: 'yediEminSalesIndHeadingConfirm',
    headingResult: 'yediEminSalesIndHeadingResult',
    labelSellerIdentity: 'yediEminSalesIndLabelSellerIdentity',
    labelSellerName: 'yediEminSalesIndLabelSellerName',
    labelSellerSurname: 'yediEminSalesIndLabelSellerSurname',
    labelSellerEmail: 'yediEminSalesIndLabelSellerEmail',
    labelSellerPhone: 'yediEminSalesIndLabelSellerPhone',
    labelSellerIban: 'yediEminSalesIndLabelSellerIban',
    placeholderEmailOptional: 'yediEminSalesIndPlaceholderEmailOptional',
    btnHesaplarimdan: 'yediEminSalesIndBtnHesaplarimdan',
    labelPlate: 'yediEminSalesIndLabelPlate',
    labelSecureAmount: 'yediEminSalesIndLabelSecureAmount',
    labelBuyerPhone: 'yediEminSalesIndLabelBuyerPhone',
    labelResultRef: 'yediEminSalesIndLabelResultRef',
    labelResultRefGoi: 'yediEminSalesIndLabelResultRefGoi',
    headingNote: 'yediEminSalesIndHeadingNote',
    resultNoteQnParagraph: 'yediEminSalesIndResultNoteQnParagraph',
    btnVazgec: 'yediEminSalesIndBtnVazgec',
    btnGeri: 'yediEminSalesIndBtnGeri',
    btnIleri: 'yediEminSalesIndBtnIleri',
    btnOnay: 'yediEminSalesIndBtnOnay',
    btnAnaSayfa: 'yediEminSalesIndBtnAnaSayfa',
    popupTitle: 'yediEminSalesIndPopupTitle',
    srFormatAmount: 'yediEminSalesIndSrFormatAmount',
    amountCurrencySuffix: 'yediEminSalesIndAmountCurrencySuffix',
    msgEmailCheckHint: 'yediEminSalesIndMsgEmailCheckHint',
    msgIbanRequired: 'yediEminSalesIndMsgIbanRequired',
    msgAmountRequired: 'yediEminSalesIndMsgAmountRequired',
    msgPlateRequired: 'yediEminSalesIndMsgPlateRequired',
    msgPhoneSellerConflict: 'yediEminSalesIndMsgPhoneSellerConflict',
    msgPhoneBuyerRequired: 'yediEminSalesIndMsgPhoneBuyerRequired',
    msgPhoneBuyerAlt: 'yediEminSalesIndMsgPhoneBuyerAlt',
    msgPhoneInvalid: 'yediEminSalesIndMsgPhoneInvalid',
    msgAmountInfoPopup: 'yediEminSalesIndMsgAmountInfoPopup',
};

@Component({
    selector: 'sales-individual',
    templateUrl: './sales-individual.component.html',
    styleUrls: ['./sales-individual.component.css']
})

export class SalesIndividualComponent extends SiriusBaseComponent<any> implements AfterViewInit {

    @ViewChild('SellerIban') sellerIban: any;
    @ViewChild('SellerEmail') sellerEmail: any;
    @ViewChild('Plate') plate: any;
    @ViewChild('SalesAmount') salesAmount: any;
    @ViewChild('BuyerPhone') buyerPhone: ElementRef;
    @ViewChild('ownAccounts') ownAccounts: OwnAccountsComponent;
    @ViewChild('messagePopup') messagePopup: MessageShowComponent;

    salesTransactionInformationItem: SalesTransactionInformationModel = new SalesTransactionInformationModel();
    mernisNo: string;
    pageNumber: number = 0;
    profileEmail: string;
    searchForm: FormGroup;
    branchArray: any[];

    isBuyerPhoneNotValid: boolean = false;
    isPlateValid: boolean = true;
    isIbanValid: boolean = true;
    isEmailValid: boolean = false;
    isAmountValid: boolean = true;
    referenceNumber: string = "0";
    referenceNumberGoi = "0";
    bankName: string;
    formattedIban: string;
    popUpMessage: string;
    popUpTitle = 'Uyarı';

    emailNotValid: boolean = false;

    phoneValidation: string;
    commissionAmount: number = 0;
    totalAmount: string;
    totalAmountDec: number;
    amountMinThanCommissionError: string;
    licencePlateError: string;
    confirmMessageFilled: string;
    confirmMessageExtra: string;
    confirmMessage: string;
    confirmMessageComm: string;
    resultMessage: string;
    errorMessage: string;
    sellerIbanMessage: string;
    amountError: string;
    sellerIbanValidationMessage: string;

    showBackToMainButton: boolean = false;
    ownAccountsCheck: boolean = false;

    headingSellerInfo = 'Bireysel Satış - Satıcı Bilgisi';
    headingSalesInfo = 'Bireysel Satış - Satış Bilgisi';
    headingConfirm = 'Bireysel Satış - Satış Kaydı Onay';
    headingResult = 'Bireysel Satış - Satış Kaydı Sonuç';
    labelSellerIdentity = 'Ruhsat Sahibi Kimlik No';
    labelSellerName = 'Ruhsat Sahibi Ad';
    labelSellerSurname = 'Ruhsat Sahibi Soyad';
    labelSellerEmail = 'Ruhsat Sahibi E-Posta Adresi';
    labelSellerPhone = 'Ruhsat Sahibi Telefon Numarası';
    labelSellerIban = 'Satıcı IBAN';
    placeholderEmailOptional = 'opsiyonel';
    btnHesaplarimdan = 'Hesaplarımdan';
    labelPlate = 'Aracın Plakası';
    labelSecureAmount = 'Güvenli Ödeme Sistemi Üzerinden Ödenmesi Gereken Bedel';
    labelBuyerPhone = 'Alıcı Telefon Numarası';
    labelResultRef = 'İşlem Referans No';
    labelResultRefGoi = 'Güvenli Ödeme İşlem Referans No';
    headingNote = 'Not';
    resultNoteQnParagraph = 'QN ile başlayan referans numaranız ile noterlikten tescil işleminizi yapabilirsiniz. İlgili referans ile tescil işlemi gerçekleştikten sonra ödeme işlemi gerçekleştirilecektir.';
    btnVazgec = 'Vazgeç';
    btnGeri = 'Geri';
    btnIleri = 'İleri';
    btnOnay = 'Onay';
    btnAnaSayfa = 'Ana Sayfa';
    srFormatAmount = '##,##0.00 TL';
    amountCurrencySuffix = ' TL';
    msgEmailCheckHint = 'Lütfen girdiğiniz e-posta adresini kontrol ediniz.';
    msgIbanRequired = 'IBAN bilgisi zorunludur.';
    msgAmountRequired = 'Ödenecek tutar bilgisi zorunludur.';
    msgPlateRequired = 'Plaka bilgisi zorunludur.';
    msgPhoneSellerConflict = 'Satıcı telefonu girilemez.';
    msgPhoneBuyerRequired = 'Alıcı telefonu bilgisi zorunludur.';
    msgPhoneBuyerAlt = 'Alıcı telefon bilgisi zorunludur.';
    msgPhoneInvalid = 'Cep telefonu numarası geçersiz.';
    msgAmountInfoPopup = 'QNB Güvenli Ödeme Sistemi ile sadece araç satış bedelinin nakit ödenecek kısmı ile işlem yapılabilir. Hesabınıza transfer edilmesini beklediğiniz tutarı giriniz.';

    regexPlate = /^(0[1-9]|[1-7][0-9]|8[01])((\s?[a-zA-Z]\s?)(\d{4,5})|(\s?[a-zA-Z]{2}\s?)(\d{3,4})|(\s?[a-zA-Z]{3}\s?)(\d{2,4}))$/;
    maskTel = ['(', /[5]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
    maskIBAN = ['TR', /\d/, /\d/, /\s/, /\d/, /\d/, /\d/, /\d/, /\s/, /\d/, /\d/, /\d/, /\d/, /\s/, /\d/, /\d/, /\d/, /\d/, /\s/, /\d/, /\d/, /\d/, /\d/, /\s/, /\d/, /\d/, /\d/, /\d/, /\s/, /\d/, /\d/];


    private profileInfo: MemberInfo = new MemberInfo(); 

    constructor(private apiService: IndividualSalesService, private validateService: ValidationService,
        private commonService: CommonService) {
        super();
    }

    OnInit() {
        this.apiService.dataServiceInstance = this.dataService;
        this.validateService.dataServiceInstance = this.dataService;
        this.branchArray = this.commonService.publicEftList.BranchArray;

        this.loadSalesIndividualResourceStrings();

        let response = this.apiService.getCustomerInfo().toPromise();
        response.then((result) => {
            this.profileInfo = <MemberInfo>result;
            this.profileEmail = this.profileInfo ? this.profileInfo.Email : "";
            this.ownAccountsCheck = this.profileInfo.HasAcc;
        });
    }

    private loadSalesIndividualResourceStrings(): void {
        const r = (key: string, fallback: string) => this.commonService.getStringResource(key, fallback);

        this.confirmMessage = r(SALES_INDIVIDUAL_KEYS.confirmMessage, this.confirmMessage || '');
        this.confirmMessageComm = r(SALES_INDIVIDUAL_KEYS.confirmMessageComm, this.confirmMessageComm || '');
        this.resultMessage = r(SALES_INDIVIDUAL_KEYS.resultMessage, this.resultMessage || '');
        this.errorMessage = r(SALES_INDIVIDUAL_KEYS.errorMessage, this.errorMessage || '');
        this.amountMinThanCommissionError = r(SALES_INDIVIDUAL_KEYS.amountMinThanCommissionError, this.amountMinThanCommissionError || '');
        this.sellerIbanMessage = r(SALES_INDIVIDUAL_KEYS.sellerIbanMessage, this.sellerIbanMessage || '');
        this.confirmMessageExtra = r(SALES_INDIVIDUAL_KEYS.confirmMessageExtra, this.confirmMessageExtra || '');
        if (this.confirmMessageExtra === '0') {
            this.confirmMessageExtra = '';
        }

        this.msgEmailCheckHint = r(SALES_INDIVIDUAL_KEYS.msgEmailCheckHint, this.msgEmailCheckHint);
        this.msgIbanRequired = r(SALES_INDIVIDUAL_KEYS.msgIbanRequired, this.msgIbanRequired);
        this.msgAmountRequired = r(SALES_INDIVIDUAL_KEYS.msgAmountRequired, this.msgAmountRequired);
        this.msgPlateRequired = r(SALES_INDIVIDUAL_KEYS.msgPlateRequired, this.msgPlateRequired);
        this.msgPhoneSellerConflict = r(SALES_INDIVIDUAL_KEYS.msgPhoneSellerConflict, this.msgPhoneSellerConflict);
        this.msgPhoneBuyerRequired = r(SALES_INDIVIDUAL_KEYS.msgPhoneBuyerRequired, this.msgPhoneBuyerRequired);
        this.msgPhoneBuyerAlt = r(SALES_INDIVIDUAL_KEYS.msgPhoneBuyerAlt, this.msgPhoneBuyerAlt);
        this.msgPhoneInvalid = r(SALES_INDIVIDUAL_KEYS.msgPhoneInvalid, this.msgPhoneInvalid);
        this.msgAmountInfoPopup = r(SALES_INDIVIDUAL_KEYS.msgAmountInfoPopup, this.msgAmountInfoPopup);

        this.licencePlateError = r(SALES_INDIVIDUAL_KEYS.plateErrorResource, this.licencePlateError || this.msgPlateRequired);

        this.headingSellerInfo = r(SALES_INDIVIDUAL_KEYS.headingSellerInfo, this.headingSellerInfo);
        this.headingSalesInfo = r(SALES_INDIVIDUAL_KEYS.headingSalesInfo, this.headingSalesInfo);
        this.headingConfirm = r(SALES_INDIVIDUAL_KEYS.headingConfirm, this.headingConfirm);
        this.headingResult = r(SALES_INDIVIDUAL_KEYS.headingResult, this.headingResult);
        this.labelSellerIdentity = r(SALES_INDIVIDUAL_KEYS.labelSellerIdentity, this.labelSellerIdentity);
        this.labelSellerName = r(SALES_INDIVIDUAL_KEYS.labelSellerName, this.labelSellerName);
        this.labelSellerSurname = r(SALES_INDIVIDUAL_KEYS.labelSellerSurname, this.labelSellerSurname);
        this.labelSellerEmail = r(SALES_INDIVIDUAL_KEYS.labelSellerEmail, this.labelSellerEmail);
        this.labelSellerPhone = r(SALES_INDIVIDUAL_KEYS.labelSellerPhone, this.labelSellerPhone);
        this.labelSellerIban = r(SALES_INDIVIDUAL_KEYS.labelSellerIban, this.labelSellerIban);
        this.placeholderEmailOptional = r(SALES_INDIVIDUAL_KEYS.placeholderEmailOptional, this.placeholderEmailOptional);
        this.btnHesaplarimdan = r(SALES_INDIVIDUAL_KEYS.btnHesaplarimdan, this.btnHesaplarimdan);
        this.labelPlate = r(SALES_INDIVIDUAL_KEYS.labelPlate, this.labelPlate);
        this.labelSecureAmount = r(SALES_INDIVIDUAL_KEYS.labelSecureAmount, this.labelSecureAmount);
        this.labelBuyerPhone = r(SALES_INDIVIDUAL_KEYS.labelBuyerPhone, this.labelBuyerPhone);
        this.labelResultRef = r(SALES_INDIVIDUAL_KEYS.labelResultRef, this.labelResultRef);
        this.labelResultRefGoi = r(SALES_INDIVIDUAL_KEYS.labelResultRefGoi, this.labelResultRefGoi);
        this.headingNote = r(SALES_INDIVIDUAL_KEYS.headingNote, this.headingNote);
        this.resultNoteQnParagraph = r(SALES_INDIVIDUAL_KEYS.resultNoteQnParagraph, this.resultNoteQnParagraph);
        this.btnVazgec = r(SALES_INDIVIDUAL_KEYS.btnVazgec, this.btnVazgec);
        this.btnGeri = r(SALES_INDIVIDUAL_KEYS.btnGeri, this.btnGeri);
        this.btnIleri = r(SALES_INDIVIDUAL_KEYS.btnIleri, this.btnIleri);
        this.btnOnay = r(SALES_INDIVIDUAL_KEYS.btnOnay, this.btnOnay);
        this.btnAnaSayfa = r(SALES_INDIVIDUAL_KEYS.btnAnaSayfa, this.btnAnaSayfa);
        this.popUpTitle = r(SALES_INDIVIDUAL_KEYS.popupTitle, this.popUpTitle);
        this.srFormatAmount = r(SALES_INDIVIDUAL_KEYS.srFormatAmount, this.srFormatAmount);

        this.amountCurrencySuffix = this.commonService.getStringResource(
            SALES_INDIVIDUAL_KEYS.amountCurrencySuffix,
            this.amountCurrencySuffix);
    }

    private formValidation(): void {
        if (this.pageNumber === 1) {
            if (this.sellerIban && this.sellerIban.value == null && !this.isIbanValid) {
              this.sellerIbanValidationMessage = this.msgIbanRequired;
            }
        }

    }

    ngAfterViewInit() {
        //Sayfa yüklendikten sonra default validasyon mesajları set edilir..
        this.formValidation();
    }

    showPanel(pageIndex: number) {
        $("kendo-maskedtextbox").addClass("form-control");
        $("kendo-numerictextbox").addClass("form-control");
        //$("kendo-numerictextbox").css("font", "400 13.3333px Arial");
        //$("kendo-maskedtextbox").css("font", "400 13.3333px Arial"); 
        $("kendo-numerictextbox").css("font-size", "16px");
        $("kendo-maskedtextbox input").css("font-size", "16px"); 

        if (pageIndex === -1 && this.pageNumber !== 3) //footer
            return true;
        return pageIndex == this.pageNumber
    }

    private ibanValid(event: any): void {   
        //this.commonService.showLoadingAnimate.next(false);
        let verifyPromise = this.verifyIBAN().toPromise().then((verifyResult) => {
           // console.log(verifyResult);
            if (!verifyResult.IsValid) {
                this.isIbanValid = false;
              //this.sellerIban.isValid = false;
              this.sellerIbanValidationMessage = verifyResult.ResultMessage;
                if (verifyResult.ForceLogOut)
                    this.commonService.logOutClient();
            }
            else {
                this.isIbanValid = true;
              //this.sellerIban.isValid = true;
              this.sellerIbanValidationMessage = '';
            }
          //  this.commonService.showLoadingAnimate.next(true);
        } );      
    }

    private phoneValid(event: any): void {
        if (this.salesTransactionInformationItem.BuyerPhone.replace(/"/g, "").replace(/'/g, "").replace(/\(|\)/g, "").replace(/-/g, "").replace(/\s/g, '') ==
            this.profileInfo.PhoneNumber.replace(/"/g, "").replace(/'/g, "").replace(/\(|\)/g, "").replace(/-/g, "").replace(/\s/g, '')) {

            this.isBuyerPhoneNotValid = true;
            this.phoneValidation = this.msgPhoneSellerConflict;
        }

        else if (this.salesTransactionInformationItem.BuyerPhone.replace(/_/g, "").replace(/\s/g, '').length != 14) {
            this.isBuyerPhoneNotValid = true;
            this.phoneValidation = this.msgPhoneBuyerRequired;
        }
        else {
            this.isBuyerPhoneNotValid = false;
            let promise = this.validateService.validatePhonenumber(this.salesTransactionInformationItem.BuyerPhone).toPromise();
            promise.then((result) => {
                this.phoneValidation = this.msgPhoneInvalid;
                this.isBuyerPhoneNotValid = !result.IsValid;
            }); 
        }
    }
      
    private verifyIBAN() { 
        return this.validateService.verifyIBAN(this.salesTransactionInformationItem.SellerIban,'','B');
    }

    private getCalculateStpCommission() { 
        return this.apiService.getStpCommission(this.salesTransactionInformationItem.SalesAmount);
    }

    private createStpSeller() {
        return this.apiService.createStpSellerTransaction(this.salesTransactionInformationItem);
    }

    private updateEmail() {
        return this.apiService.updateCustomerInfo(this.profileInfo);
    }

    private controlEmail(event: any): void {

        if (this.profileEmail == null || this.profileEmail == '') {
            this.emailNotValid = false;
            return;
        } 

        if (!this.profileEmail.includes('@') || !this.profileEmail.includes('.')) {
            this.emailNotValid = true;
            return;
        }

        this.emailNotValid = false;
        let promise = this.validateService.validateMail(this.profileEmail).toPromise();
        promise.then((serviceResult) => {
            if (serviceResult.IsValid == false) {
                this.emailNotValid = true; 
            }
        });
  }

  private plateValid(event: any): void {
    if (this.plate && (this.plate.value == undefined || this.plate.value == null || this.plate.value == '')) {
      this.isPlateValid = false;
      this.licencePlateError = this.msgPlateRequired;
    }
    else
    {
      this.isPlateValid = true;
      this.licencePlateError = "";
    }
  }

  private amountValid(event: any): void {
    if (this.salesAmount && (this.salesAmount.value == undefined || this.salesAmount.value == null || this.salesAmount.value == '')) {
      this.isAmountValid = false;
      this.amountError = this.msgAmountRequired;
    }
    else {
      this.isAmountValid = true;
      this.amountError = "";
    }
  }

    private formValidationForEmptyFields(): boolean {
        let result = true;
        if (this.sellerIban && (this.sellerIban.value == undefined || this.sellerIban.value == null || this.sellerIban.value == '')) { 
            this.isIbanValid = false;
            this.sellerIbanValidationMessage = this.msgIbanRequired;
            result = false;
        }
        if (this.plate && (this.plate.value == undefined || this.plate.value == null || this.plate.value == '')) { 
          this.isPlateValid = false;
          this.licencePlateError = this.msgPlateRequired; 
            result = false;
        }
        if (this.salesAmount && (this.salesAmount.value == undefined || this.salesAmount.value == null || this.salesAmount.value == '')) { 
          this.isAmountValid = false;
          this.amountError = this.msgAmountRequired; 
            result = false;
        }
        
        if (this.buyerPhone && (this.buyerPhone.nativeElement.value == undefined || this.buyerPhone.nativeElement.value == null || this.buyerPhone.nativeElement.value == '')) {
            this.isBuyerPhoneNotValid = true;
            this.phoneValidation = this.msgPhoneBuyerRequired;
            result = false;
        }
        return result;
    }

  nextFunction() {

    if (this.profileInfo.GetName) {
      this.commonService.StartTransaction('AccountProfileTransaction', SharedModel.PageName_Preferences);
      return;
    }
        if (this.pageNumber === 0) {
            if (this.emailNotValid || (this.sellerEmail.errors && (this.sellerEmail.touched || this.sellerEmail.dirty))) {
                return;
            }
            if ((this.profileInfo.Email == "" || this.profileInfo.Email == null || this.profileInfo.Email == undefined) && this.sellerEmail && this.sellerEmail.value != null && this.sellerEmail.value != '') {
                    this.emailNotValid = false;
                    this.profileInfo.Email = this.sellerEmail.value;
                    this.profileInfo.UpdatedFieldInfo = "E";
                    this.updateEmail().toPromise().then((result) => { 
                        
                    }); 
                    this.pageNumber++;
            }
            else {
                this.pageNumber++;

            }
        }
        else if (this.pageNumber === 1) {
            //form empty field validations
            if (!this.formValidationForEmptyFields()) {
                return;
            }

            //IBAN VALIDASYON
            //if (!this.ibanValid())
            //    return false; 

            if (this.salesTransactionInformationItem.SellerIban && this.isIbanValid && this.salesTransactionInformationItem.Plate
                && this.salesTransactionInformationItem.BuyerPhone
                && this.salesTransactionInformationItem.SalesAmount) {

                this.totalAmount = this.salesAmount.value.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + this.amountCurrencySuffix; 
                let bankCode = this.salesTransactionInformationItem.SellerIban.substring(3, 7);
                this.formattedIban = 'TR' + this.salesTransactionInformationItem.SellerIban.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();

              if (this.branchArray != null)
              {
                let branch = this.branchArray.filter(c => c.BankCode == bankCode)[0];

                this.bankName = branch ? branch.BankFriendlyName : "";
                //1 - IBAN VALIDASYONU ONBLUR'DA YAPILDI
              }
               
                //2 - TELEFON NO VALİDASYONU //
                if (this.salesTransactionInformationItem.BuyerPhone.replace(/"/g, "").replace(/'/g, "").replace(/\(|\)/g, "").replace(/-/g, "").replace(/\s/g, '') ==
                    this.profileInfo.PhoneNumber.replace(/"/g, "").replace(/'/g, "").replace(/\(|\)/g, "").replace(/-/g, "").replace(/\s/g, '')) {

                    this.isBuyerPhoneNotValid = true;
                  this.phoneValidation = this.msgPhoneSellerConflict;
                }
                else if (this.salesTransactionInformationItem.BuyerPhone.replace(/_/g, "").replace(/\s/g, '').length != 14) {
                    this.isBuyerPhoneNotValid = true;
                  this.phoneValidation = this.msgPhoneBuyerAlt;
                }           


                this.confirmMessageFilled = '';
                this.totalAmountDec = this.salesTransactionInformationItem.SalesAmount;
                // 4- TUTAR VALİDASYONU //
                let promise = this.getCalculateStpCommission().toPromise();
              promise.then((result) => {

                //////////////PhoneValidation//////////
                this.isBuyerPhoneNotValid = false;
                let promise = this.validateService.validatePhonenumber(this.salesTransactionInformationItem.BuyerPhone).toPromise();
                promise.then((result) => {
                  this.phoneValidation = this.msgPhoneInvalid;
                  this.isBuyerPhoneNotValid = !result.IsValid;
                });
                //////////////PhoneValidation/////////


                    this.commissionAmount = result.CommissionAmount;

                    if (this.totalAmountDec <= this.commissionAmount) {
                        //this.salesAmount.isValid = false;
                      this.isAmountValid = false;
                      this.amountError = this.amountMinThanCommissionError;
                        //this.salesAmount.errorMessage = this.amountMinThanCommissionError;
                        return;
                    }
                    else { 
                        if (!this.isBuyerPhoneNotValid && this.isPlateValid) {
                            ////////////CONFIRM MESSAGE///////////////////////////////////
                            if (this.commissionAmount == 0) {

                                this.confirmMessageFilled = this.commonService.prepareStringText(this.confirmMessageComm,
                                    [{ key: 'formattedIban', value: this.formattedIban.bold() },
                                    { key: 'bankName', value: this.bankName.bold(), },
                                    { key: 'totalAmount', value: this.totalAmount.bold() }]);
                            }
                            else {
                                this.confirmMessageFilled = this.commonService.prepareStringText(this.confirmMessage,
                                    [{ key: 'formattedIban', value: this.formattedIban.bold() },
                                    { key: 'bankName', value: this.bankName.bold(), },
                                    { key: 'totalAmount', value: this.totalAmount.bold() },
                                    { key: 'commissionAmount', value: (this.commissionAmount.toLocaleString('tr-TR', { style: 'decimal' }) + this.amountCurrencySuffix).bold() }]);

                            }


                            this.pageNumber++;
                        }
                    }
                });
                     
            }
        }
        else {
            this.pageNumber++;
        }
    }

    backFunction() {
        if (this.pageNumber === 1) {
            this.OnInit();
        }
        this.pageNumber--;
    }

    submitFunction() {
        this.salesTransactionInformationItem.CustomerType = "G";

        let response = this.apiService.getCustomerInfo().toPromise();
        response.then((result) => {
            this.profileInfo = <MemberInfo>result;
            this.profileEmail = this.profileInfo ? this.profileInfo.Email : "";
        });


        this.createStpSeller().toPromise().then((result) => {
            this.showBackToMainButton = true;
          this.referenceNumber = result.ResultID;
          this.referenceNumberGoi = result.ResultIDGoi;
            this.errorMessage = result.ResultMessage;
            this.pageNumber++;
            if (result.ResultCode == 10) { 
                setTimeout(() => {
                    this.commonService.logOutClient();
                }, 10000);
            }
        });
    }

    cancelFunction() {
        this.commonService.StartTransaction(TransactionNames.InnerMenuTransaction, SharedModel.PageName_MainInnerPage);
    }

    onCopy() {
        var dummy = document.createElement("textarea");
        document.body.appendChild(dummy);
        dummy.value = this.referenceNumber;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);
    
    }

    showOwnAccounts() {
        this.ownAccounts.showPopup();
    }

    onAccountSelect(accNumber: string) {
        let shortedAccNumber = accNumber.substring(2);
        this.sellerIban.value = shortedAccNumber; 
        this.salesTransactionInformationItem.SellerIban = shortedAccNumber;
        this.ibanValid(null);
    }

    showIbanInfo(e: any) {
        this.messagePopup.showCancelButton = false;
        this.popUpMessage = this.sellerIbanMessage;
        this.messagePopup.showPopup();
        e.preventDefault();

  }

  showAmountInfo(e: any) {
    this.messagePopup.showCancelButton = false;
    this.popUpMessage = this.msgAmountInfoPopup;
    this.messagePopup.showPopup();
    e.preventDefault();
  }

    phoneMaskValid(e: any) {
        if (this.buyerPhone.nativeElement.classList.contains('ng-valid')) {
            this.isBuyerPhoneNotValid = false; 
        }
        else {
          this.isBuyerPhoneNotValid = true;
          this.phoneValidation = this.msgPhoneBuyerRequired;
        }
    }

  onMessageAccepted() {

  }
}
